<template>
	<div class="concept ma-4">
		<h4 class="my-5">{{ $t("document.header") }}</h4>
		<v-card
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.update_note.path" target="_BLANK">
							{{ documents.update_note.name_chi }}
						</a>
						<a v-else :href="documents.update_note.path" target="_BLANK">
							{{ documents.update_note.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.update_note.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.user_guide.path" target="_BLANK">
							{{ documents.user_guide.name_chi }}
						</a>
						<a v-else :href="documents.user_guide.path" target="_BLANK">
							{{ documents.user_guide.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.user_guide.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
			v-if="$cookies.get('user_level')=='TEACHER'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.teacher_manual.path" target="_BLANK">
							{{ documents.teacher_manual.name_chi }}
						</a>
						<a v-else :href="documents.teacher_manual.path" target="_BLANK">
							{{ documents.teacher_manual.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.teacher_manual.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='TEACHER'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.key_features_teacher.path" target="_BLANK">
							{{ documents.key_features_teacher.name_chi }}
						</a>
						<a v-else :href="documents.key_features_teacher.path" target="_BLANK">
							{{ documents.key_features_teacher.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.key_features_teacher.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.group_experiment_teacher.path" target="_BLANK">
							{{ documents.group_experiment_teacher.name_chi }}
						</a>
						<a v-else :href="documents.group_experiment_teacher.path" target="_BLANK">
							{{ documents.group_experiment_teacher.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.group_experiment_teacher.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='TEACHER'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.campus_network_setup_preparation.path" target="_BLANK">
							{{ documents.campus_network_setup_preparation.name_chi }}
						</a>
						<a v-else :href="documents.campus_network_setup_preparation.path" target="_BLANK">
							{{ documents.campus_network_setup_preparation.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.campus_network_setup_preparation.version }}
					</div>
				</div>
			</div>
		</v-card>		
		<v-card
		v-if="$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.admin_operate.path" target="_BLANK">
							{{ documents.admin_operate.name_chi }}
						</a>
						<a v-else :href="documents.admin_operate.path" target="_BLANK">
							{{ documents.admin_operate.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.admin_operate.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.onsite_guide.path" target="_BLANK">
							{{ documents.onsite_guide.name_chi }}
						</a>
						<a v-else :href="documents.onsite_guide.path" target="_BLANK">
							{{ documents.onsite_guide.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.onsite_guide.version }}
					</div>
				</div>
			</div>
		</v-card>
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		name: 'concept',
		components: {
		},
		data:function(){
			return{
				documents:{
					user_guide: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-General_User_Guide.pdf',
						name: 'General User Guide - English',
						name_chi: '一般用戶指南 - 英文',
						version: '2026-08-26'
					},
					teacher_manual: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Teacher_Full_Manual.pdf',
						name: 'Full Teacher Manual - English',
						name_chi: '老師完全手冊— 英文版本',
						version: '2026-08-27'
					},
					key_features_teacher: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Key_Features_of_Teacher.pdf',
						name: 'Key Features of Teacher - English',
						name_chi: '老師常用功能手冊— 英文版本',
						version: '2026-08-27'
					},
					group_experiment_teacher: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Group_Experiment_Guideline_for_Teacher.pdf',
						name: 'Group Experiment Guideline (Teacher) - English',
						name_chi: '多人參與實驗指引（老師）— 英文版本',
						version: '2026-02-03'
					},
					campus_network_setup_preparation: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Campus_Network_Setup_Preparation_Guide.pdf',
						name: 'Campus Network Setup Preparation Guide - English',
						name_chi: '校園網絡設置準備指南 — 英文版本',
						version: '2025-11-17'
					},
					admin_operate: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Administrator_Operation_Guideline.pdf',
						name: 'Administrator Operation Guideline - English',
						name_chi: '管理員操作指南 — 英文版本',
						version: '2026-08-25'
					},
					onsite_guide: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Onsite_Installation_Checklist.pdf',
						name: 'Onsite Installation Checklist - English',
						name_chi: '現場安裝準備清單 — 英文版本',
						version: '2026-08-27'
					},					
					update_note: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Update_note-20260818.pdf',
						name: 'Update Note 2026-08-18 - English',
						name_chi: '更新日誌 2026-08-18 — 英文版本',
						version: '2026-08-27'
					},
				},
			}
		},
		mounted: function(){
			var self = this;
		},
		methods:{
		}
	}
</script>